import React, { useMemo } from "react";
import { useSelector } from "react-redux";

import { MdOutlineShoppingCart, MdStorage } from "react-icons/md";
import { FaDigitalTachograph, FaShippingFast, FaTrailer } from "react-icons/fa";
import { TbTicket, TbTruckDelivery } from "react-icons/tb";
import { BiPackage } from "react-icons/bi";

import Navbar from "./Navbar";
import ProfileModal from "./Components/ProfileModal/ProfileModal";
import ReferralPromo from "./Components/ReferralPromo/ReferralPromo";
import AuthComponent from "../../Pages/Authentication/Components/AuthComponent/AuthComponent";
import {
  AppViewBanner,
  AppViewButton,
  AppViewDrawerLink,
} from "../AppView/AppView";
import { canUseAppView } from "../../helpers/appView";

export const SHIPPER_NAV_ITEMS = [
  { label: "Orders", i18nKey: "nav:orders", url: "/orders", name: "shipper.access.order.view", badge: "unReadOrders", icon: MdOutlineShoppingCart },
  { label: "Ship", i18nKey: "nav:ship", url: "/", name: "shipper.access.shipment.view", badge: null, icon: FaShippingFast },
  { label: "Shipments", i18nKey: "nav:shipments", url: "/shipments", name: "shipper.access.shipment.view", badge: "unReadShipments", icon: FaTrailer },
  { label: "Finances", i18nKey: "nav:finances", url: "/payments", name: "shipper.access.payment.view", badge: null, icon: FaDigitalTachograph },
  { label: "Tickets", i18nKey: "nav:tickets", url: "/Tickets", name: "shipper.access.ticket.view", badge: null, icon: TbTicket },
  { label: "Carriers", i18nKey: "nav:carriers", url: "/Carriers", name: "shipper.access.carrier.view", badge: null, icon: TbTruckDelivery },
  { label: "Products", i18nKey: "nav:products", url: "/products", name: "shipper.access.product.view", badge: null, icon: BiPackage },
  { label: "Packages", i18nKey: "nav:packages", url: "/Packages", name: "shipper.access.product.view", badge: null, icon: BiPackage },
  { label: "Sales channels", i18nKey: "nav:salesChannels", url: "/Marketplaces", name: "", badge: null, icon: MdStorage },
];

export const SHIPPER_HELPER_ALLOWED_URLS = [
  "/",
  "/shipments",
  "/orders",
  "/products",
  "/payments",
];

function ShipperNavbar() {
  const user = useSelector((state) => state.user);

  const shipperPermissions = useMemo(
    () =>
      SHIPPER_NAV_ITEMS.map((item) => ({
        ...item,
        unReadData: item.badge ? user?.[item.badge] : null,
      })),
    [user],
  );

  const isOwner =
    (user?.role === "Shipper" || user?.role === "oneTimeShipper") &&
    !user?.parent_id;
  const visibleNavItems = useMemo(
    () =>
      isOwner
        ? shipperPermissions
        : shipperPermissions.filter(
            (item) =>
              SHIPPER_HELPER_ALLOWED_URLS.includes(item.url) &&
              item.name &&
              user?.mergedPermissions?.includes(item.name),
          ),
    [isOwner, shipperPermissions, user?.mergedPermissions],
  );

  // Referrals belong to the Shipper parent account only. The backend rejects
  // other roles but not helpers (they share the parent's role), so helpers
  // are kept out here.
  const canRefer = user?.role === "Shipper" && !user?.parent_id;

  // The app view (the phone app's web build) for shipper logins and their
  // store users; one-time shippers also land on this navbar on some pages.
  const showAppView = canUseAppView(user);

  const profileModal = ({ onClose }) => (
    <ProfileModal onClose={onClose} style={{ top: "50px", right: "0" }} />
  );

  return (
    <>
      <AuthComponent />
      <Navbar
        navItems={visibleNavItems}
        profileImage={user?.profile_image}
        profileModal={profileModal}
        rightActions={
          canRefer || showAppView ? (
            <>
              {canRefer && <ReferralPromo />}
              {showAppView && <AppViewButton />}
            </>
          ) : null
        }
        drawerActions={showAppView ? <AppViewDrawerLink /> : null}
      />
      {showAppView && <AppViewBanner />}
    </>
  );
}

export default ShipperNavbar;
